// @ts-nocheck
import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useListContext } from 'react-admin';
import CardItemBoards from './CardItemBoards';

const useStyles = makeStyles((theme) => ({
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        borderRadius: '8px',
    },
}));

const DataGridCardCustom = (props) => {
    const classes = useStyles();
    const { data, ids } = useListContext();
    const { CardComponent = CardItemBoards } = props;

    if (!data || !ids || ids.length === 0) {
        return (
            <Box className={classes.cardContainer}>
                <Typography variant='body2' color='textSecondary' style={{ textAlign: 'center', gridColumn: '1 / -1' }}>
                    Aucune donnée disponible
                </Typography>
            </Box>
        );
    }

    return (
        <Box className={classes.cardContainer}>
            {ids.map((id) => {
                const record = data[id];
                if (!record) return null;

                return <CardComponent key={id} record={record} />;
            })}
        </Box>
    );
};

export default DataGridCardCustom;
